/* eslint-disable jsx-a11y/control-has-associated-label,jsx-a11y/anchor-has-content,import/no-unresolved */
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MAIN_ICON_COLORS } from 'assets/components';
import { useSetting } from '../../../utilities/sharedHooks/settings';
import Icon from '../../../components/Icon';
import { ICONS } from '../../../components/Icon/constants';
import { useUserPersonalInfo } from '../../../utilities/sharedHooks/user';

const AboutUs = () => {
  const { t: translate } = useTranslation();

  const [ledgerSupportEmailAddress] = useSetting('server_configurations', 'support_email_address');

  const { isUS } = useUserPersonalInfo();

  return (
    <div className="mt-3 d-flex flex-column w-100 h-lg-100 h-md-100 h-sm-100">
      <p className="text-f3 text-dark pe-5 text-bold letter-spacing-1 line-height-sm-1 line-height-2">
        {translate('settings_about_tab_label')}
      </p>
      <p className="mt-3 text-f6 text-shadow">{translate('settings_about_tab_desc')}</p>
      <div className="p-4 d-flex flex-column bg-lighter rounded-extra mt-4">
        <div className="rounded-extra w-100">
          <img src="./assets/images/aboutUs.png" width="100%" alt="About Us" />
        </div>
        <p className="text-dark text-f5 mt-4 letter-spacing-2">
          {translate('settings_about_us_note_1')}
        </p>
        {!isUS && (
          <p className="text-dark text-f5 mt-4 letter-spacing-2">
            {translate('settings_about_us_note_2')}
          </p>
        )}
        <p className="text-dark text-f5 mt-4 letter-spacing-2">
          {translate('settings_about_us_note_3')}
        </p>
        <p className="text-f5 text-dark mt-4 letter-spacing-2">
          <Trans
            i18nKey="settings_about_us_contact_us"
            values={{
              support_email: ledgerSupportEmailAddress,
            }}
            components={[
              <a
                key="contact-link-2"
                className="text-decoration-none"
                href={`mailto:${ledgerSupportEmailAddress}`}
                rel="noreferrer"
              />,
            ]}
          />
        </p>

        <a
          className="d-flex text-decoration-none mt-4 cursor-pointer"
          href="https://twitter.com/CL_Technology"
          target="_blank"
          rel="noreferrer">
          <div
            className="d-flex justify-content-center rounded-max bg-gray-brach h-sm-32px w-32px pb-sm-0 py-1 "
            style={{ paddingTop: '2px' }}>
            <div className="h-100 w-md-14px w-sm-12px w-12px">
              <Icon icon={ICONS.TWITTER} color={MAIN_ICON_COLORS.WHITE} />
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

export default AboutUs;
